import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
const testimonialsData = [{
  quote: "This app is so helpful for tracking vaccinations, lineage and kidding/calving dates. This is an amazing upgrade from the Google Calendar and Excel Spreadsheets I've been using. This is the first app I've found that actually covers all aspects of my farm. Everything in one place with quick access and simple alerts.",
  name: "FarmGirlFromFranklin80",
  service: "Apple App Store · May 14, 2026",
  initial: "F"
}, {
  quote: "The tracking features on this app goes beyond just tracking financially.",
  name: "Thanks for the song",
  service: "Apple App Store · May 14, 2026",
  initial: "T"
}, {
  quote: "Great for farms with different types of animals.",
  name: "FarmerB1977",
  service: "Apple App Store · May 15, 2026",
  initial: "F"
}, {
  quote: "Best app to use to keep track of farm records.",
  name: "larson@14",
  service: "Apple App Store · May 14, 2026",
  initial: "L"
}];
export default function Farmertestimonials() {
  return <section data-section-id="263359" id="farmertestimonials" className="w-full bg-background py-16 md:py-24 text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center max-w-3xl mx-auto">
          <h2 className="font-default text-3xl font-bold tracking-tight text-primary md:text-4xl">
            What farmers are actually saying.
          </h2>
          <p className="mt-4 text-base text-muted-foreground font-default">
            Every review below is a real 5-star review on the Apple App Store. No paid endorsements, no stock quotes — just family farms using the app.
          </p>
        </div>
        <div className="mx-auto grid max-w-6xl grid-cols-1 gap-8 md:grid-cols-2">
          {testimonialsData.map((testimonial, index) => <Card key={index} data-index={index} className="flex h-full flex-col justify-between border-[3px] border-primary bg-card rounded-2xl shadow-md transition-shadow duration-300 hover:shadow-lg">
              <CardContent className="flex h-full flex-col items-start px-6 pb-8 pt-10 text-left">
                <div className="flex items-center gap-1 mb-4 text-chart-2 text-xl tracking-widest">
                  <span>★★★★★</span>
                </div>
                <p className="mb-8 flex-grow text-lg leading-[1.6] text-foreground font-default">
                  "{testimonial.quote}"
                </p>
                <div className="mt-auto flex items-center gap-4">
                  <SafeHydrate><Avatar className="size-14 border-2 border-accent">
                    <AvatarFallback className="bg-accent text-accent-foreground font-semibold">
                      {testimonial.initial}
                    </AvatarFallback>
                  </Avatar></SafeHydrate>
                  <div className="text-left">
                    <h4 className="font-default text-base font-bold text-primary">
                      {testimonial.name}
                    </h4>
                    <p className="text-xs font-medium text-muted-foreground font-default">
                      {testimonial.service}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}